import { Injectable, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { StatePersistenceService, StorageSyncType } from '@spartacus/core';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { CustomUserActions } from './actions';
import { CustomUserSelectors } from './selectors';
import { StateWithCustomUser } from './user-state';

export interface SyncedCustomUserState {
  legalEntityStatus?: boolean;
}

@Injectable({ providedIn: 'root' })
export class UserPersistenceService implements OnDestroy {
  protected subscription = new Subscription();

  constructor(
    private statePersistenceService: StatePersistenceService,
    private store: Store<StateWithCustomUser>,
  ) {}

  sync(): void {
    this.subscription.add(
      this.statePersistenceService.syncWithStorage({
        key: 'customUser',
        storageType: StorageSyncType.LOCAL_STORAGE,
        state$: this.getState(),
        onRead: (state) => this.onReadState(state),
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private getState(): Observable<SyncedCustomUserState> {
    return this.store
      .select(CustomUserSelectors.getLegalEntityStatus)
      .pipe(map((legalEntityStatus) => ({ legalEntityStatus })));
  }

  private onReadState(state: SyncedCustomUserState = {}): void {
    if (state.legalEntityStatus) {
      this.store.dispatch(new CustomUserActions.SetLegalEntityStatus(state.legalEntityStatus));
    }
  }
}
